import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './store/reducers/rootReducer';
import { Provider } from 'react-redux';
import { reduxFirestore, getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import fbConfig from './store/api/fbConfig';
import { withExtraArgument } from 'redux-thunk';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { createFirestoreInstance } from 'redux-firestore';


import { useSelector } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';
import { useEffect } from 'react';



import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import 'firebase/compat/storage';


const rrfConfig = {
  userProfile: 'users',            // where user profiles are stored in Firestore
  useFirestoreForProfile: true,   // use Firestore instead of Realtime DB
};


const middleware = applyMiddleware(
  withExtraArgument({
    getFirebase,
    getFirestore
  })
);

const store = createStore(
  rootReducer,
  compose(
    middleware,
    reduxFirestore(fbConfig)
  )
);

function AuthIsLoaded({ children }) {
  

  /*
  const auth = useSelector((state) => state.firebase.auth);

  console.log(auth)
  if (!isLoaded(auth)) {
    return (
      <div id="loader-wrapper">
        <div id="loader"> loading</div>
        <div className="loader-section section-left"></div>
        <div className="loader-section section-right"></div>
      </div>
    );
  }

  return("sdf")*/
  return children;
}
const theme = createTheme(); // you can customize it later


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider
      firebase={firebase}
      config={fbConfig}
      dispatch={store.dispatch}
      createFirestoreInstance={createFirestoreInstance}
      >
      <ThemeProvider theme={theme}>
      <AuthIsLoaded>
        <App />
      </AuthIsLoaded>
      </ThemeProvider>
    </ReactReduxFirebaseProvider>
  </Provider>
);

serviceWorker.unregister();
